var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","height":_vm.size + 'px',"viewBox":"0 -960 960 960","width":_vm.size + 'px',"fill":"currentColor"}},[_c('path',{attrs:{"d":"m233-120 65-281L80-590l288-25 112-265 112 265 288 25-218 189 65 281-247-149-247 149Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }